import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

interface VideoViewDialogProps {
  open: boolean;
  videoLink: string | null;
  onClose: () => void;
}

const VideoViewDialog: React.FC<VideoViewDialogProps> = ({
  open,
  videoLink,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Video Preview</DialogTitle>

      <DialogContent>
        <Box
          sx={{
            mt: 2,
            width: "100%",
            height: "60vh", // container height
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#000", // dark background for better view
            borderRadius: "10px",
          }}
        >
          <video
            controls
            src={videoLink ?? ""}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain", // ⭐ makes video fit inside box
              borderRadius: "10px",
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VideoViewDialog;
